import React from 'react';
import { Card, Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useCardsCarouselStyles } from '../../CardsCarouselV2/CardsCarouselV2.styles';
import { useRoleCardStyles } from '../../RoleCardV2/RoleCard.styles';
import { useSkeletonCardStyles } from './SkeletonCards.styles';

/**
 * Placeholder for career path role cards while they're loading.
 * Renders 4 cards to match common 4 role card scenario.
 */
export const SkeletonCards = () => {
  const carouselStyles = useCardsCarouselStyles();
  const cardStyles = useRoleCardStyles();
  const styles = useSkeletonCardStyles();

  return (
    <div className={carouselStyles.homepageStack}>
      {new Array(4).fill(0).map((_, index) => (
        <div key={index} className={carouselStyles.homepageStackitem}>
          <Card className={cardStyles.homepageCard}>
            <Skeleton>
              <div className={styles.container}>
                <SkeletonItem size={20} style={{ width: '50%' }} />
                <SkeletonItem style={{ width: '40%' }} />
                <SkeletonItem style={{ width: '90%' }} />
                <SkeletonItem style={{ width: '100%' }} />
                <SkeletonItem style={{ width: '80%' }} />
              </div>
            </Skeleton>
          </Card>
        </div>
      ))}
    </div>
  );
};
